import { atom } from 'jotai';
import { RemoteImageAlert_GetList_ResponseItem } from '~/common/typescript/apis/RemoteImageAlertAPIs';

export const s2singleItemsLEFTAtom = atom<RemoteImageAlert_GetList_ResponseItem[]>([]);

export const s2singleItemsRIGHTAtom = atom<RemoteImageAlert_GetList_ResponseItem[]>([]);

export const s2singleLoadingAtom = atom<{ isLoading: boolean; text?: string }>({
  isLoading: false,
  text: '',
});